import { call, put, takeLatest } from 'redux-saga/effects';
import { AuthLoginActionTypes } from './authTypes';
import { authLoginApiResponseSuccess, authLoginApiResponseError } from './authActions';
import { getMeApi, webRefreshApi, webLogoutApi } from '../api/authNode';
import { persistor } from '../store/index';

function* sessionCheckSaga(): any {
  try {
    let response: any = yield call(getMeApi);

    if (response?.error && response?.status === 401) {
      const refreshResult: any = yield call(webRefreshApi);
      if (!refreshResult?.error) {
        response = yield call(getMeApi);
      }
    }

    if (response?.error) {
      yield put(
        authLoginApiResponseError(
          AuthLoginActionTypes.SESSION_CHECK,
          response.message || 'Not authenticated',
        ),
      );
      return;
    }

    yield put(authLoginApiResponseSuccess(AuthLoginActionTypes.SESSION_CHECK, response));
  } catch (error: any) {
    yield put(
      authLoginApiResponseError(
        AuthLoginActionTypes.SESSION_CHECK,
        error?.message || 'Session check failed',
      ),
    );
  }
}

function* logoutUserSaga(): any {
  try {
    yield call(webLogoutApi);
  } catch {
    // clear local state even if API call fails
  } finally {
    yield call([persistor, 'purge']);
    yield put(authLoginApiResponseSuccess(AuthLoginActionTypes.LOGOUT_USER, {}));
  }
}

export default function* authSaga() {
  yield takeLatest(AuthLoginActionTypes.SESSION_CHECK, sessionCheckSaga);
  yield takeLatest(AuthLoginActionTypes.LOGOUT_USER, logoutUserSaga);
}
